export default __webpack_public_path__ + "assets/visualization/hall_edit_mr_a59d5d74124bbc2d6d0d8019fb706b4c.hdr";